/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    errorMas: {
        id: 'quoteandbind.EnvLinProduct.views.exposures.Atleast one Nature of Operations / Occupancies (Internal Classification) required for the location(s)',
        defaultMessage: 'Atleast one Nature of Operations / Occupancies (Internal Classification) required for the location(s)'
    },
    noneMsg: {
        id: 'quoteandbind.EnvLinProduct.views.exposures.None',
        defaultMessage: 'None'
    },
    aucunMsg: {
        id: 'quoteandbind.EnvLinProduct.views.exposures.Aucun',
        defaultMessage: 'Aucun'
    }
});